import { cn } from '@dc-shared-web/lib'

export default function GradientContainer({
  excludeTop = false,
  excludeBottom = false,
  className,
  topClassName,
  bottomClassName,
  children,
}: {
  excludeTop?: boolean
  excludeBottom?: boolean
  className?: string
  topClassName?: string
  bottomClassName?: string
  children: React.ReactNode
}) {
  return (
    <>
      {!excludeTop && (
        <div
          className={cn(
            'tw-h-8 tw-w-full tw-sticky tw-top-0 tw-left-0 tw-right-0 tw-bg-gradient-to-b tw-from-white',
            className,
            topClassName
          )}
        />
      )}
      {children}
      {!excludeBottom && (
        <div
          className={cn(
            'tw-h-8 tw-w-full tw-sticky tw-bottom-0 tw-left-0 tw-right-0 tw-bg-gradient-to-t tw-from-white',
            className,
            bottomClassName
          )}
        />
      )}
    </>
  )
}
